/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  Col,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Container,
  Row,
} from "reactstrap";
// core components
import Products from "components/Tables/Product.js";
import ProductModal from "components/Modals/Product.js";
import Header from "components/Headers/ProductHeader.js";
import ProductDataService from "../../services/ProductDataService";
import WarehouseDataService from "../../services/WarehouseDataService";

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultModal: false,
      products: [],
      perPage: 10,
      currentPage: 1,
      currentProduct: {},
      searchId: 'nama',
      tabs: 1,
      warehouseId: -1,
      warehouses: [],
    };
    this.productDataService = new ProductDataService();
    this.warehouseDataService = new WarehouseDataService();
  }

  getWarehouses() {
    this.warehouseDataService.getList(1, 99999, null)
      .then((data) => {
        return {
          warehouses: data.data.warehouse_list !== null && data.data.errorMessage === undefined ? data.data.warehouse_list : [],
        };
      })
      .then((res) => this.setState({ warehouses: res.warehouses }));
    setTimeout(() => {
      this.setState({ errorMessage: undefined });
    }, 5000);
  }  

  toggleModal = (state, formType, product, initialTab) => {
    this.setState({
      [state]: !this.state[state],
      formType: formType,
      initialTab: initialTab,
      currentProduct: {
        ...product,
        sell_price: Number(product?.sell_price).toLocaleString(),
        price: Number(product?.price).toLocaleString(),
      },
    });
  };

  toggleNavs = (e, state, index) => {
    e.preventDefault();
    this.setState({
      [state]: index,
      products: [],
      currentProduct: {},
      searchValue: '',
      perPage: 10,
      currentPage: 1,
    }, () => {
      this.fetchData(this.state.keyword);
    });
  };

  toggleWarehouseModal = (state, formType, warehouse) => {
    this.setState({
      [state]: !this.state[state],
      formType: formType,
      currentWarehouse: {
        ...warehouse,
      },
    });
  };

  async componentDidMount() {
    this.fetchData()
    this.getWarehouses()
  }

  handleSearch = (e) => {
    const keyword = e.target.value;
    this.setState({
      currentPage: keyword !== undefined && keyword !== '' ? 1 : this.state.currentPage,
      keyword: keyword,
    }, () => {
      this.fetchData(keyword);
    });
  }

  downloadProducts() {
    this.productDataService.export().catch(err => {
      this.setState({ 'errorMessage': err })
      setTimeout(() => {
        this.setState({ errorMessage: undefined })
      }, 5000);
    })
  }

  fetchData(keyword) {
    const { tabs, searchId, warehouseId, currentPage, perPage } = this.state;

    if (tabs === 1) {
      // Produk Aktif
      if (searchId === 'nama' || keyword === undefined || keyword === '') {
        this.productDataService.getList(keyword, warehouseId, currentPage, perPage, 0, false) // true = is_active
            .then(res => this.setState(res));
      } else {
        this.productDataService.getByBarcode(keyword, currentPage, perPage, true)
            .then(res => this.setState(res));
      }
    } else if (tabs === 2) {
      // Produk Tidak Aktif
      if (searchId === 'nama' || keyword === undefined || keyword === '') {
        this.productDataService.getList(keyword, warehouseId, currentPage, perPage, 1, false) // false = is_active
            .then(res => this.setState(res));
      } else {
        this.productDataService.getByBarcode(keyword, currentPage, perPage, false)
            .then(res => this.setState(res));
      }
    }

    setTimeout(() => {
      this.setState({ errorMessage: undefined });
    }, 5000);
  }

  handlePageClick = (e) => {
    const selectedPage = e;

  this.setState({
      currentPage: selectedPage,
    }, () => {
      this.fetchData(this.state.keyword)
    });
  }

  handleNextPageClick() {
    this.handlePageClick(this.state.currentPage + 1)
  }

  handlePreviousPageClick() {
    this.handlePageClick(this.state.currentPage - 1)
  }

  setSuccessMessage = (message) => {
    this.setState({ successMessage: message })
  }

  setSearchId = (mode) => {
    if (mode === this.state.searchId) {
      return;
    }
    this.setState({ searchId: mode });
  }

  handleSearchByWarehouseId(e) {
    let warehouseId = e.target.value;

    this.setState({ warehouseId }, () => this.fetchData(this.state.keyword));
  }

  render() {
    const pageNumbers = [];
    for (var index = 1; index <= this.state.totalPages; index++) {
      pageNumbers.push(index)
    }

    const MAX_PAGES_DISPLAYED = 10; // Define the maximum number of page numbers to display at once
    const { currentPage, totalPages } = this.state;

    // Calculate the range of page numbers to display
    const startPage = Math.max(currentPage - Math.floor(MAX_PAGES_DISPLAYED / 2), 1);
    const endPage = Math.min(startPage + MAX_PAGES_DISPLAYED - 1, totalPages);

    // Include the minimum and maximum page numbers
    const minPage = 1;
    const maxPage = totalPages;

    const pageNumbersToDisplay = [];

    // Add the minimum page number if it's not in the range
    if (minPage < startPage) {
      pageNumbersToDisplay.push(minPage);
    }

    // Add ellipsis if there's a gap between the minimum page and the start of the range
    if (startPage > minPage) {
      pageNumbersToDisplay.push('...');
    }

    // Add the page numbers within the range
    for (let i = startPage; i <= endPage; i++) {
      pageNumbersToDisplay.push(i);
    }

    // Add ellipsis if there's a gap between the range and the maximum page
    if (endPage < maxPage) {
      pageNumbersToDisplay.push('...');
    }

    // Add the maximum page number if it's not in the range
    if (maxPage > endPage) {
      pageNumbersToDisplay.push(maxPage);
    }

    const renderPageNumbers =
      (
        <div>
          <ul className="pagination">
            {pageNumbersToDisplay.map(number => (
              <PaginationItem key={number} className={currentPage === number ? "active" : ""}>
                {number === '...' ? (
                  <PaginationLink disabled>{number}</PaginationLink>
                ) : (
                  <PaginationLink onClick={() => this.handlePageClick(number)}>
                    {number}
                  </PaginationLink>
                )}
              </PaginationItem>
            ))}
          </ul>
        </div>
      );

    return (
      <>
        <Header tabs={this.state.tabs} toggleNavs={this.toggleNavs}/>
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Daftar produk</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        onClick={() => this.toggleModal("formModal", "add")}
                        size="sm"
                      >
                        Tambah baru
                      </Button>
                      {/* <Button
                        color="primary"
                        onClick={() => this.toggleWarehouseModal("formWarehouseModal", "add")}
                        size="sm"
                      >
                        Tambah warehouse baru
                      </Button> */}
                      {/* <WarehouseModal
                        toggleModal={() => this.toggleWarehouseModal("formWarehouseModal")}
                        formModal={this.state.formWarehouseModal}
                        formType={this.state.formType}
                        currentWarehouse={this.state.currentWarehouse}
                        setSuccessMessage={this.setSuccessMessage}
                        fetchData={this.fetchData.bind(this)}
                      /> */}
                      <ProductModal
                        toggleModal={() => this.toggleModal("formModal")}
                        formModal={this.state.formModal}
                        formType={this.state.formType}
                        currentProduct={this.state.currentProduct}
                        setSuccessMessage={this.setSuccessMessage}
                        fetchData={this.fetchData.bind(this)}
                        warehouses={this.state.warehouses}
                        initialTab={this.state.initialTab}
                      />
                    </Col>
                    {this.state.successMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="success">
                          {this.state.successMessage}
                        </Alert>
                      </Col>
                    )}
                    {this.state.errorMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="danger">
                          {this.state.errorMessage}
                        </Alert>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col xs="6" className="mt-3 align-items-right">
                      <FormGroup>
                        <InputGroup className="input-group-alternative mb-4 flex-nowrap">
                          <InputGroupAddon addonType="prepend">
                            <ButtonGroup>
                              <Button
                                type="button"
                                color="primary"
                                outline={this.state.searchId !== 'nama'}
                                onClick={() => this.setSearchId('nama')}
                              >
                                Nama Produk
                              </Button>
                              <Button
                                type="button"
                                color="primary"
                                outline={this.state.searchId !== 'barcode'}
                                onClick={() => this.setSearchId('barcode')}
                              >
                                Barcode
                              </Button>
                            </ButtonGroup>
                          </InputGroupAddon>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className={this.state.searchId === 'barcode' ? 'ni ni-tag' : 'ni ni-zoom-split-in'} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            className="form-control-alternative"
                            placeholder={this.state.searchId === 'barcode' ? 'Scan atau ketik barcode' : 'Search produk'}
                            onChange={(e) => this.handleSearch(e)}
                            type="text"
                          />
                          {((localStorage.getItem("user_roles") || "")
                                    .split(',')
                                    .map(role => role.trim().toLowerCase())
                                    .some(role => role === "admin")) && (
                            <Input placeholder="Warehouse"
                              name="search_id"
                              onChange={this.handleSearchByWarehouseId.bind(this)}
                              type="select" >
                                <option value='-1'>Semua warehouses</option>
                                <option value='0'>Produk tanpa warehouse</option>
                                {this.state.warehouses?.map(warehouse => (
                                  <option value={warehouse.warehouse_id}>{warehouse.warehouse_name}</option>
                                ))}
                            </Input>
                          )}
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col xs={5} className="mt-3 mr-n6">
                      <Button
                        color="primary"
                        size="md"
                        onClick={() => this.downloadProducts()}>
                        Download
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <Products
                  products={this.state.products}
                  toggleModal={this.toggleModal}
                  formModal={this.state.formModal}
                  formType={this.state.formType}
                  setSuccessMessage={this.setSuccessMessage}
                  fetchData={this.fetchData.bind(this)}
                  warehouses={this.state.warehouses}
                  tabs={this.state.tabs}
                />
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      className="pagination pagination-lg justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                        <PaginationLink
                          onClick={() => this.handlePreviousPageClick()}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                          <span className="sr-only">Previous</span>
                        </PaginationLink>
                      </PaginationItem>
                      {renderPageNumbers}
                      <PaginationItem className={this.state.currentPage === this.state.totalPages && "disabled"}>
                        <PaginationLink
                          onClick={() => this.handleNextPageClick()}
                        >
                          <i className="fas fa-angle-right" />
                          <span className="sr-only">Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default List;
